module.exports = __webpack_public_path__ + "static/img/6.b57e6f9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/1/sp/6.png
// module id = Ejw2
// module chunks = 0